const getters = {
  sidebar: state => state.app.sidebar,
  menubar: state => state.app.sidebar,
  language: state => state.app.language,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  routes: state => state.user.routes,
  empresa: state => state.empresa.empresa,
  usuario: state => state.user.usuario,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,
  months: state => state.app.months,
  secret: state => state.app.secret,
  baseurl: state => state.app.baseurl,
  tipo_inventario: state => state.app.tipo_inventario,
  sessionUUID: state => state.app.sessionUUID
}
export default getters
